import { PureComponent } from "react";
import classnames from "classnames";
import BadgeComponent from "components/core/badge/badge-component";
import Colors from "styles/colors";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";
import Arrow from "static/svg/docs/arrow-up.svg";
import { TAB_CLICKED } from "/constants/bigbrain-event-types";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
import ProgressBarComponent from "../../progressbar/progressbar-component";
import { componentStyles } from "./vertical-timer-tab-desktop-component.scss";

const VERTICAL_TAB_BUTTON_DIV_CLASS_NAME = "vertical-timer-tab-desktop-title-button";
export default class VerticalTimerTabComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.onKeyDown = generateOnKeyDownHandler(this.handleTitleClick);
  }

  handleTitleClick = () => {
    const { setSelectedTab, index, title, getTabIdentifier, isSelected } = this.props;
    const identifier = getTabIdentifier ? getTabIdentifier(this.props) : title;

    BigBrain("track", TAB_CLICKED, {
      kind: identifier,
      info1: index,
      info2: isSelected
    });
    setSelectedTab(index);
  };

  onTabClicked = (e) => {
    this.blurTab(e);
    this.handleTitleClick();
  };

  blurTab = (e) => {
    e?.target?.closest(`.${VERTICAL_TAB_BUTTON_DIV_CLASS_NAME}`)?.blur();
  };

  shouldShowProgressbar = () => {
    const { isSelected, timerEnabled, alwaysShowProgressbar } = this.props;
    return alwaysShowProgressbar || (timerEnabled && isSelected);
  };

  render() {
    const {
      title,
      tabTitleRenderer,
      tabContentRenderer,
      content,
      badgeText,
      fontColor,
      selectedFontColor,
      titleFontWeight,
      fontSize,
      selectedFontSize,
      lineHeight,
      isSelected,
      forceProgressbarDone,
      duration,
      showArrow,
      progressbarColor,
      arrowSize,
      timerEnabled,
      ...rest
    } = this.props;

    const color = isSelected ? Colors[selectedFontColor] : Colors[fontColor];

    return (
      <div
        tabIndex={0}
        role="tab"
        className={classnames("vertical-timer-tab-desktop-container", {
          "vertical-timer-tab-desktop-container-selected": isSelected
        })}
        style={{ height: lineHeight || fontSize }}
      >
        <div
          role="button"
          tabIndex={0}
          className={classnames(VERTICAL_TAB_BUTTON_DIV_CLASS_NAME, {
            "vertical-timer-tab-desktop-title-button-selected": isSelected
          })}
          onClick={this.onTabClicked}
          onKeyDown={this.onKeyDown}
          style={{ fontSize: isSelected ? selectedFontSize : fontSize }}
        >
          {tabTitleRenderer ? (
            tabTitleRenderer(title, { ...rest, isSelected })
          ) : (
            <MondayMarkupLanguageComponent
              tagName="span"
              style={{ color, fontWeight: titleFontWeight, lineHeight }}
              text={title}
            />
          )}
          {badgeText && (
            <div className="vertical-timer-tab-title-badge-margin">
              <BadgeComponent badgeText={badgeText} />
            </div>
          )}
          <span className="vertical-timer-tab-arrow-wrapper">
            {showArrow && (
              <Arrow
                className={classnames("vertical-timer-tab-arrow", { selected: isSelected })}
                style={{ color, width: arrowSize }}
              />
            )}
          </span>
        </div>
        <div className={classnames("vertical-timer-tab-desktop-progress-container")}>
          {this.shouldShowProgressbar() && (
            <ProgressBarComponent
              duration={duration}
              forceProgressbarDone={forceProgressbarDone || !timerEnabled}
              progressbarColor={progressbarColor}
              enabled={isSelected}
            />
          )}
        </div>
        {(content || tabContentRenderer) && (
          <div
            className={classnames("vertical-timer-tab-desktop-content-container", {
              "vertical-timer-tab-desktop-content-container-selected": isSelected
            })}
          >
            <div className="vertical-timer-tab-desktop-content">
              {tabContentRenderer ? (
                tabContentRenderer(content, { ...rest })
              ) : (
                <MondayMarkupLanguageComponent text={content} />
              )}
            </div>
          </div>
        )}
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
